<template>
  <div class="personal-mine-handle" v-loading="isLoading" v-scroll-list>
  <div>
    <table>
      <thead>
        <th style="width: 40%;">任务名称</th>
        <th style="width: 30%;">所属项目</th>
        <th style="width: 15%;">截止时间</th>
        <th style="width: 15%;">完成时间</th>
      </thead>
      <tr class="task-title" :class="{'change-class': !todoIsOpen}">
        <td><i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': todoIsOpen}" @click="todoIsOpen = !todoIsOpen"></i>未完成<span>（{{todoTotal}}）</span></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tbody ref="list1" v-if="todoIsOpen">
        <tr v-for="item in todoList" :key="item.id">
          <td>
            <div class="cell">
              <toolTip class="text-blue" :max-width="'80%'" :title="item.task_name" @click.native="taskClick(item)">
                <span>{{item.task_name}}</span>
              </toolTip>
              <span class="child-tip" v-if="item.task_level > 1">{{childText(item.task_level)}}</span>
            </div>
          </td>
          <td>
            <div class="cell">
              <toolTip class="text-blue" :max-width="'90%'" :title="item.project.title" @click.native="projectClick(item)">
                <span>{{item.project.title}}</span>
              </toolTip>
              <span>  </span>
            </div>
          </td>
          <!-- {{item.start_time ? item.start_time.replace(/-/g,'/'):''}} -  -->
          <td>{{item.end_time ? item.end_time.replace(/-/g,'/'):''}}</td>
          <td>{{item.task_completed_time ? item.task_completed_time.replace(/-/g,'/'):''}}</td>
        </tr>
        <div v-if="todoList.length === 0 && todoIsOpen" class="not-task-box">
          <Nothing :config="{type:'img_no_data', tip: '暂无任务' }"></Nothing>
        </div>
        <tr  v-if="todoLoading" class="loading-box">
          <td colspan="4"><i class="el-icon-loading"></i></td>
        </tr>
      </tbody>

      <tr class="task-title" v-if="completeList.length > 0 "  :class="{'change-class': !completeIsOpen}">
        <td><i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': completeIsOpen}" @click="completeIsOpen = !completeIsOpen"></i>已完成<span>（{{completeTotal}}）</span></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tbody class="complete-box" ref="list2" v-if="completeIsOpen">
        <tr v-for="item in completeList" :key="item.id">
          <td>
            <div class="cell">
              <toolTip class="text-blue" :max-width="'80%'" :title="item.task_name" @click.native="taskClick(item)">
                <span>{{item.task_name}}</span>
              </toolTip>
              <span class="child-tip" v-if="item.task_level > 1">{{childText(item.task_level)}}</span>
            </div>
          </td>
          <td>
            <div class="cell">
              <toolTip class="text-blue" :max-width="'90%'" :title="item.project.title" @click.native="projectClick(item)">
                <span>{{item.project.title}}</span>
              </toolTip>
            </div>
          </td>
          <!-- {{item.start_time ? item.start_time.replace(/-/g,'/'):''}} -  -->
          <td>{{item.end_time ? item.end_time.replace(/-/g,'/'):''}}</td>
          <td>{{item.task_completed_time ? item.task_completed_time.replace(/-/g,'/'):''}}</td>
        </tr>
        <div>
          <i v-if="completeLoading" class="el-icon-loading"></i>
        </div>
      </tbody>
    </table>
  </div>

  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Nothing from '@/components/nothing'
import api from '@/services/api/mine/mine'
export default {
  props: ['onlyReal', 'uid'],
  components: {
    Nothing,
  },
  data() {
    let _this = this
    return {
      complete: {
        page: 1,
        per_page: 20,
        uid: _this.uid
      },
      todo: {
        page: 1,
        per_page: 20,
        sort_rule: 'due_date_sort',
        uid: _this.uid
      },
      completeList: [], // 已完成列表
      completeTotal: 0, // 已完成总数
      completeIsOpen: true, // 已完成是否展开
      completeFinish: false,
      completeLoading: false,
      todoList: [], // 未完成列表
      todoTotal: 0,// 未完成总数
      todoIsOpen: true, // 未完成是否展开
      todoFinish: false,
      todoLoading: false,
      colorList: [],// 颜色列表
      check: ''
    }
  },
  directives: {
    'scroll-list': {
      inserted(el, binding, vnode) {
        let _this = vnode.context
        const scrollHandler = () => {
          const scrollTop = el.scrollTop + el.clientHeight
          let list1 = _this.$refs.list1
          let list2 = _this.$refs.list2
          if (scrollTop > (list1.offsetHeight - 50) && _this.todoList.length > 0 && !_this.todoLoading) {
            _this.todoLoad()
          }
          if (scrollTop > (list1.offsetHeight + list2.offsetHeight - 50 && _this.completeList.length > 0 && !_this.completeLoading)) {
            _this.completeLoad()
          }
        }
        el.addEventListener('scroll', scrollHandler);
      }
    }
  },
  computed: {
    ...mapState('mine/mine', {
      queryMsg: state => state.queryMsg
    }),
    isLoading() {
      return (!this.todoFinish && this.todoList.length === 0) || (!this.completeFinish && this.completeList.length === 0)
    },
    isNothing() {
      let fl = this.completeList.length === 0 && this.todoList.length === 0 && this.completeFinish && this.todoFinish && !this.isLoading
      this.$emit('nothing', fl)
      return fl
    },
  },
  watch: {
    queryMsg: {
      handler() {
        this.complete.keyword = this.queryMsg.keyword
        this.complete.my_execution = this.queryMsg.my_execution
        this.complete.project_id = this.queryMsg.project_id

        this.todo.keyword = this.queryMsg.keyword
        this.todo.my_execution = this.queryMsg.my_execution
        this.todo.project_id = this.queryMsg.project_id
        this.todo.sort_rule = this.queryMsg.sort_rule
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // this.init()
  },
  methods: {
    ...mapActions('task/task', ['updateStatus']),
    childText(level) {
      switch (level) {
        case 2:
          return '子任务'
          break
        case 3:
          return '孙任务'
          break
      }
    },
    init() {
      this.complete.page = 1
      this.completeList = []
      this.completeTotal = 0
      this.todo.page = 1
      this.todoList = []
      this.todoTotal = 0
      this.getCompleteTask()
      this.getTodoTask()
    },
    async getCompleteTask() {
      this.completeFinish = false
      let result = await api.relatedToMeCompletedTasksIndex({ ...this.complete })
      this.completeList.push(...result.data)
      this.completeTotal = result.total
      if (this.completeList.length === this.completeTotal || result.data.length === 0) {
        this.completeFinish = true
      } else {
        this.completeFinish = false
      }
    },
    async getTodoTask() {
      this.todoFinish = false
      let result = await api.relatedToMeUndoneTasksIndex({ ...this.todo })
      this.todoList.push(...result.data)
      this.todoTotal = result.total
      if (this.todoList.length === this.todoTotal || result.data.length === 0) {
        this.todoFinish = true
      } else {
        this.todoFinish = false
      }
    },
    async completeLoad(resolve) {
      if (this.completeLoading || this.completeFinish) return
      this.completeLoading = true
      this.complete.page = this.complete.page + 1
      await this.getCompleteTask()
      this.completeLoading = false
    },
    async todoLoad() {
      if(this.todoLoading || this.todoFinish) return
      this.todoLoading = true
      this.todo.page = this.todo.page + 1
      await this.getTodoTask()
      this.todoLoading = false
    },
    async taskStatusChange({ item, index, isCompete }) {
      await this.updateStatus({ task_id: item.id, task_stage: isCompete ? '进行中' : '已完成' })
      let key = isCompete ? 'completeTotal' : 'todoTotal' // 判断那个数组
      this[key] - 1 < 0 ? this[key] = 0 : this[key] = this[key] - 1 // 相应数量-1
      // if (isCompete) {
      //   this.todoList = []
      //   this.todoTotal = 0
      //   this.todo.page = 1
      //   this.completeList.splice(index, 1)
      //   this.$nextTick(() => {
      //     this.getTodoTask()
      //   })
      // } else {
      //   this.completeList = []
      //   this.completeTotal = 0
      //   this.complete.page = 1
      //   this.$nextTick(() => {
      //     this.getCompleteTask()
      //   })
      //   this.todoList.splice(index, 1)
      // }
      this.todoList = []
      this.todoTotal = 0
      this.todo.page = 1
      this.completeList = []
      this.completeTotal = 0
      this.complete.page = 1
      this.$nextTick(() => {
        this.getCompleteTask()
        this.getTodoTask()
      })
    },
    taskClick(item) {
      this.$emit('taskClick', { task_id: item.id, task_list_id: item.task_list_id })
    },
    projectClick(data) {
      this.$emit('projectClick', data.project_id)
    },
    openDetail(id) {
      this.check = id
    }
  }
}
</script>
<style lang="scss">
.personal-mine-handle {
  height: 100% ;
  overflow-x: hidden;
  scrollbar-width: none;
  .not-task-box {
    height: 400px;
  }
  table {
    table-layout: fixed;
    width: 100%;
    height: auto;
    font-size: 14px;
    box-shadow: inset 0 -1px 0 0 rgba(32, 32, 32, 0.08); /* 模拟下边框 */
        // inset 0 1px 0 0 rgba(32, 32, 32, 0.08); /* 模拟上边框 */
    position: relative;
    tbody {
      position: relative;
      .cell {
        width: 100%;
        display: flex;
      }
    }
    thead {
      position: sticky;
      top: 0px;
      right: 0;
      left: 0;
      box-shadow:
        inset 0 -1px 0 0 rgba(32, 32, 32, 0.08); /* 模拟下边框 */
      background-color: #fff;
      z-index: 100;
      th:first-child {
        padding-left: 40px;
      }
    }
    th {
      text-align: left;
      height: 53px;
      padding: 0 16px;
      box-shadow: inset -1px 0 0 0 rgba(32, 32, 32, 0.08);
      color: rgba(32, 32, 32, 0.6);
      position: relative;
      z-index: 100;
    }
    tr {
      height: 48px;
      td:first-child {
        padding-left: 40px;
      }
      td:last-child {
        box-shadow: inset 0 -1px 0 0 rgba(32, 32, 32, 0.08);
      }
    }
    tbody {
      tr {
        td:first-child {
          padding-left: 62px;
        }
      }
    }
    td {
      height: 48px;
      text-align: left;
      padding: 0 16px;
      box-shadow: inset -1px 0 0 0 rgba(32, 32, 32, 0.08),inset 0 -1px 0 0 rgba(32, 32, 32, 0.08);
      color: rgba(32, 32, 32, 0.9);
    }
    .task-title {
      font-size: 16px;
      font-weight: bold;
      position: sticky;
      background-color: #fff;
      top: 53px;
      left: 0;
      right: 0;
      z-index: 100;
      td:not(:first-child) {
        box-shadow: inset 0 -1px 0 0 rgba(32, 32, 32, 0.08);
      }
      i {
        font-size: 14px;
        color: #C9C9C9;
        margin-right: 8px;
        margin-left: -8px;
      }
      span {
        color: rgba(32, 32, 32, 0.60);
        font-size: 14px;
        font-weight: 400;
      }
    }
    .change-class {
      td {
        box-shadow: inset 0 -1px 0 0 rgba(32, 32, 32, 0.08);
      }
    }
    .complete-box {
      td {
        color: rgba(32, 32, 32, 0.60) !important;
      }
    }
    .loading-box {
      td {
        text-align: center;
      }
    }
    .child-tip {
      padding: 4px 6px;
      border-radius: 4px;
      background-color: #EEEEEE;
      color: rgba(32, 32, 32, 0.60);
      font-size: 12px;
      margin-left: 8px;
    }
  }
}
</style>
